// TennisTrack Hub — Lista Atleti | 029 Project
import React, { useState, useEffect, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../../utils/api';
import Navbar from '../../components/Navbar';
import './Atleti.css';

const ListaAtleti = () => {
  const [atleti, setAtleti] = useState([]);
  const [cerca, setCerca] = useState('');
  const [loading, setLoading] = useState(true);
  const [errore, setErrore] = useState('');
  const navigate = useNavigate();

  const caricaAtleti = useCallback(async (testo = '') => {
    try {
      setLoading(true);
      const params = testo.trim() ? { cerca: testo } : {};
      const res = await api.get('/atleti', { params });
      setAtleti(res.data.atleti);
    } catch (err) {
      setErrore('Errore nel caricamento atleti.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    caricaAtleti();
  }, [caricaAtleti]);

  // Ricerca con debounce
  useEffect(() => {
    const timer = setTimeout(() => caricaAtleti(cerca), 350);
    return () => clearTimeout(timer);
  }, [cerca, caricaAtleti]);

  const sportIcon = (sport) => ({ tennis: '🎾', fitness: '💪', altro: '🏅' }[sport] || '🏅');
  const livelloColore = (livello) => ({ principiante: 'verde', intermedio: 'giallo', avanzato: 'rosso' }[livello] || 'grigio');

  return (
    <div className="page-layout">
      <Navbar />
      <main className="page-main">

        {/* Header */}
        <div className="page-header">
          <div>
            <h1>I tuoi Atleti</h1>
            <p>{atleti.length} atleta{atleti.length !== 1 ? 'i' : ''} registrat{atleti.length !== 1 ? 'i' : 'o'}</p>
          </div>
          <button className="btn btn-primary" onClick={() => navigate('/atleti/nuovo')}>
            + Nuovo atleta
          </button>
        </div>

        {/* Barra ricerca */}
        <div className="search-bar">
          <span className="search-icon">🔍</span>
          <input
            type="text"
            placeholder="Cerca per nome o cognome..."
            value={cerca}
            onChange={(e) => setCerca(e.target.value)}
          />
          {cerca && (
            <button className="search-clear" onClick={() => setCerca('')}>✕</button>
          )}
        </div>

        {errore && <div className="alert alert-error">{errore}</div>}

        {/* Lista */}
        {loading ? (
          <div className="loading-msg">Caricamento atleti...</div>
        ) : atleti.length === 0 ? (
          <div className="empty-state">
            <div className="empty-icon">🎾</div>
            <h3>{cerca ? 'Nessun atleta trovato' : 'Nessun atleta ancora'}</h3>
            <p>{cerca ? 'Prova con un altro nome.' : 'Aggiungi il tuo primo atleta per iniziare.'}</p>
            {!cerca && (
              <button className="btn btn-primary" onClick={() => navigate('/atleti/nuovo')}>
                + Aggiungi atleta
              </button>
            )}
          </div>
        ) : (
          <div className="atleti-grid">
            {atleti.map((atleta) => (
              <Link to={`/atleti/${atleta.id}`} key={atleta.id} className="atleta-card card">
                <div className="atleta-avatar">
                  {atleta.nome[0]}{atleta.cognome[0]}
                </div>
                <div className="atleta-info">
                  <h3>{atleta.nome} {atleta.cognome}</h3>
                  <div className="atleta-meta">
                    <span className="atleta-sport">{sportIcon(atleta.sport)} {atleta.sport}</span>
                    <span className={`livello-badge livello-${livelloColore(atleta.livello)}`}>
                      {atleta.livello}
                    </span>
                  </div>
                  {atleta.eta && <span className="atleta-eta">{atleta.eta} anni</span>}
                </div>
                <div className="atleta-arrow">›</div>
              </Link>
            ))}
          </div>
        )}

      </main>
    </div>
  );
};

export default ListaAtleti;
